import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  selector: 'itk-link',
  styleUrl: './link.style.scss',
  templateUrl: './link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule],
})
export class ItkLinkComponent {
  @Input() isExternal = false;
  @Input() location = '#';
  @Input() label = '';
}
